import { ZodSchema } from "@validation/utils/schemaUtils";
import { intl } from "LocaleWrapper";
import z from "zod";

export const reeferSchema = z.object({
	location: z.object({
		type: z.string(),
		sec: z.number().min(0).max(20).nullable(),
		row: z.number().min(0).max(20).nullable(),
		lay: z.number().min(0).max(20).nullable(),
	}),
	plugin: z.object({
		id: z.number().nullable(),
		timestamp: ZodSchema.requiredField(z.number()),
		temperature: ZodSchema.requiredField(z.number().min(-100).max(100)),
	}),
	plugout: z.object({
		id: z.number().nullable(),
		timestamp: z.number().nullable(),
		temperature: z.number().min(-100).max(100).nullable(),
	}),
	setPoint: z.number().min(-100).max(100).nullable(),
	checks: z.array(z.object({
		date: z.string(),
		list: z.array(z.object({
			id: z.number().nullable(),
			timestamp: z.number().nullable(),
			temperature: z.number().min(-100).max(100).nullable(),
		})),
	})),
}).superRefine((data, ctx) => {
	if (!data.plugout.timestamp && data.plugout.temperature !== null) {
		ctx.addIssue({
			code: "custom",
			message: intl.formatMessage({ id: "ZOD_VALIDATION_REQUIRED" }),
			path: [ "plugout.timestamp" ],
		});
	}

	data.checks.forEach((checkGroup, rowIndex) => {
		checkGroup.list.forEach((check, colIndex) => {
			const hasTimestamp = check.timestamp !== null;
			const hasTemperature = check.temperature !== null;

			if (hasTemperature && !hasTimestamp) {
				ctx.addIssue({
					code: "custom",
					message: intl.formatMessage({ id: "ZOD_VALIDATION_REQUIRED" }),
					path: [ "checks", rowIndex, "list", colIndex, "timestamp" ],
				});
			}

			if (hasTimestamp && !hasTemperature) {
				ctx.addIssue({
					code: "custom",
					message: intl.formatMessage({ id: "ZOD_VALIDATION_REQUIRED" }),
					path: [ "checks", rowIndex, "list", colIndex, "temperature" ],
				});
			}
		});
	});
});

export type ReeferSchemaInput = z.input<typeof reeferSchema>;
export type ReeferSchemaOutput = z.output<typeof reeferSchema>;
